import Swiper from 'swiper';

const slides = document.querySelectorAll('.c-slider-approach') || []

const cSliderApproachInit = () => {
  ;[...slides].map(slideContainer => {
    const slider = slideContainer.querySelector('.js-slider-approach')
    const navBullets = slideContainer.querySelectorAll('.js-nav-bullet')
    
    var sliderApproach = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      initialSlide: 0,
      breakpoints: {
        1024: {
          spaceBetween: 20,
          initialSlide: 0,
        },
        1280: {
          spaceBetween: 30,
          initialSlide: 1,
        },
        1440: {
          spaceBetween: 60,
          initialSlide: 1,
        }
      },
    })
    navBullets.forEach((navBullet, index) => {
      navBullet.addEventListener("click", function() {
        const navBulletID = navBullet.dataset.slideTo;
        //console.log(navBulletID);
        sliderApproach.slideTo(navBulletID);
        navBullet.classList.add("is-active");
      });
    });
    sliderApproach.on('slideChange', function () {
      -        navBullets.forEach((item, index) => {
        const itemBulletID = item.dataset.slideTo;
        item.classList.remove("is-active");
        //console.log(navBulletID);
        if (sliderApproach.activeIndex == itemBulletID) {
          item.classList.add("is-active");
        }
      });
    });
  })
}

export default cSliderApproachInit
